import { render, staticRenderFns } from "./PhoneHangIcon.vue?vue&type=template&id=97070fa0&"
import script from "./PhoneHangIcon.vue?vue&type=script&lang=ts&"
export * from "./PhoneHangIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports